// extracted by mini-css-extract-plugin
export default {"title":"DataCard_title__dVqGF","wrapper":"DataCard_wrapper__jGICq","group":"DataCard_group__i93Rx"};